const generateActions = (document) => {
  const tempActions = [];

  const targetPageComps = document.querySelector('body').querySelectorAll('[target_page]');

  targetPageComps.forEach((comp) => {
    const targetPage = comp.getAttribute('target_page');
    const id = comp.getAttribute('id');
    const { tagName } = comp;
    const href = comp.getAttribute('href');

    tempActions.push({
      UIProps: {
        id: id !== null ? id : '',
        type: tagName !== null ? tagName : ''
      },
      externalAction: {
        linkHref: href !== '#' ? href : ''
      },
      internalAction: {
        changePage: targetPage !== -1 ? targetPage : ''
      }
    });
  });

  const hrefComps = document.querySelector('body').querySelectorAll('[href]');

  hrefComps.forEach((comp) => {
    const id = comp.getAttribute('id');
    const targetPage = comp.getAttribute('target_page');
    const href = comp.getAttribute('href');
    const { tagName } = comp;

    if (targetPage === null && href !== '#' && href !== '#!') {
      tempActions.push({
        UIProps: {
          id: id !== null ? id : '',
          type: tagName !== null ? tagName : ''
        },
        externalAction: {
          linkHref: href
        },
        internalAction: {
          changePage: ''
        }
      });
    }
  });

  return tempActions;
};

export default generateActions;
